<script lang="ts">
  import '@gouvfr/dsfr/dist/component/link/link.min.css';
  import '@gouvfr/dsfr/dist/component/logo/logo.min.css';
  import '@gouvfr/dsfr/dist/component/footer/footer.min.css';
</script>

<footer
  class="fr-footer"
  id="footer">
  <div class="fr-footer__top">
    <div class="fr-container">
      <div class="fr-grid-row fr-grid-row--start fr-grid-row--gutters">
        <div class="fr-col-12 fr-col-sm-3 fr-col-md-2">
          <p class="fr-footer__top-cat">Liens utiles</p>
          <ul class="fr-footer__top-list">
            <li>
              <a
                class="fr-footer__top-link"
                href="/sitemap.xml">
                Plan du site
              </a>
            </li>
            <li>
              <a
                class="fr-footer__top-link"
                href="/nous-contacter">
                Nous contacter
              </a>
            </li>
            <li>
              <a
                class="fr-footer__top-link"
                href="/tout-savoir-sur-le-bail-reel-solidaire-brs">
                Les étapes du BRS
              </a>
            </li>
            <li>
              <a
                class="fr-footer__top-link"
                href="/notre-mission">
                Notre mission
              </a>
            </li>
            <li>
              <a
                class="fr-footer__top-link"
                href="/statistiques">
                Statistiques
              </a>
            </li>
            <li>
              <a
                class="fr-footer__top-link"
                href="/matrice-impact">
                Matrice d'impact
              </a>
            </li>
            <li>
              <a
                class="fr-footer__top-link"
                href="/espace-presse">
                Espace presse
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div class="fr-container">
    <div class="fr-footer__body">
      <div class="fr-footer__brand fr-enlarge-link">
        <a
          id="footer-operator"
          href="/"
          title="Retour à l’accueil du site - Boris (ministère chargé du logement)">
          <p class="fr-logo">
            Ministère <br />
            chargé
            <br />
            du logement
          </p>
        </a>
      </div>
      <div class="fr-footer__content">
        <p class="fr-footer__content-desc">
          BoRiS aide les ménages dans leur recherche de logements en Bail Réel
          Solidaire.
        </p>
        <ul class="fr-footer__content-list">
          <li class="fr-footer__content-item">
            <a
              target="_blank"
              rel="noopener external"
              title="info.gouv.fr - nouvelle fenêtre"
              class="fr-footer__content-link"
              href="https://info.gouv.fr">
              info.gouv.fr
            </a>
          </li>
          <li class="fr-footer__content-item">
            <a
              target="_blank"
              rel="noopener external"
              title="service-public.fr - nouvelle fenêtre"
              class="fr-footer__content-link"
              href="https://service-public.fr">
              service-public.fr
            </a>
          </li>
          <li class="fr-footer__content-item">
            <a
              target="_blank"
              rel="noopener external"
              title="legifrance.gouv.fr - nouvelle fenêtre"
              class="fr-footer__content-link"
              href="https://legifrance.gouv.fr">
              legifrance.gouv.fr
            </a>
          </li>
          <li class="fr-footer__content-item">
            <a
              target="_blank"
              rel="noopener external"
              title="data.gouv.fr - nouvelle fenêtre"
              class="fr-footer__content-link"
              href="https://data.gouv.fr">
              data.gouv.fr
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="fr-footer__bottom">
      <ul class="fr-footer__bottom-list">
        <li class="fr-footer__bottom-item">
          <a
            class="fr-footer__bottom-link"
            href="/accessibilite">
            Accessibilité : non conforme
          </a>
        </li>
        <li class="fr-footer__bottom-item">
          <a
            class="fr-footer__bottom-link"
            href="/mentions-legales">
            Mentions légales
          </a>
        </li>
        <li class="fr-footer__bottom-item">
          <a
            class="fr-footer__bottom-link"
            href="/conditions-generales-d-utilisation">
            Conditions générales d'utilisation
          </a>
        </li>
        <li class="fr-footer__bottom-item">
          <a
            class="fr-footer__bottom-link"
            href="/politique-de-confidentialite">
            Politique de confidentialite
          </a>
        </li>
      </ul>
      <div class="fr-footer__bottom-copy">
        <p>
          Sauf mention explicite de propriété intellectuelle détenue par des
          tiers, les contenus de ce site sont proposés sous <a
            href="https://github.com/etalab/licence-ouverte/blob/master/LO.md"
            target="_blank"
            rel="noopener external"
            title="Licence etalab - nouvelle fenêtre">
            licence etalab-2.0
          </a>
        </p>
      </div>
    </div>
  </div>
</footer>
